import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EcosistemasService {

  private buttonStates: { [key: string]: boolean } = {};

  constructor() { }

  // Add an EventEmitter for button state changes
  buttonStateChanged = new EventEmitter<{ buttonName: string, newState: boolean }>();
  private capas_tematicas: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public capas_tematicas$: Observable<any[]> = this.capas_tematicas.asObservable();
  private arr_info: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public arr_info$: Observable<any[]> = this.arr_info.asObservable();

  getButtonState(buttonName: string): boolean {
    return this.buttonStates[buttonName] || false;
  }

  setButtonState(buttonName: string, state: boolean): void {
    this.buttonStates[buttonName] = state;
    // Notify subscribers when the state changes
    this.buttonStateChanged.emit({ buttonName, newState: state });
  }

  updateCapasTematicas(capas_tematicas){
    this.capas_tematicas.next(capas_tematicas);
  }

  updateInfo(info){
    this.arr_info.next(info);
  }

}
